// These functions are shared between Vue search (search page) and vanilla .js search (navigation)

import { highlightSubstring } from "../../utils/DOMutils";
import { wfetch } from "../../utils/fetch";

const populateDocs = (results) => {
    let docs = [];
    const docProperties = ["author", "url", "keywords", "h1", "abstract", "title", "categories", "hx", "content", "description", "source"];

    for (const result of results) {
        if (docs.filter((doc) => result.url.toString() === doc.url).length > 0) continue;

        const doc = {};

        for (const property of docProperties) {
            if (!result[property]) continue;

            let propertyValue = result[property].toString();

            if (property === "title") propertyValue = propertyValue.replace(" | Magnolia DXP", "");

            doc[property] = propertyValue;
        }

        if (Object.keys(doc).length > 0) docs.push(doc);
    }

    return docs;
};

export const populateSources = (docs) => {
    const sources = {};
    const sortedSources = {};
    let sortedSourcesArr = [];

    for (const doc of docs) {
        if (!doc.source) continue;

        const source = doc.source;

        if (!sources[source]) sources[source] = { name: source, count: 0 };

        sources[source].count += 1;
    }

    sortedSourcesArr = Object.values(sources).sort((a, b) => b.count - a.count);

    for (const source of sortedSourcesArr) {
        sortedSources[source.name] = source;
    }

    return sources;
};

const getResults = (restUrl, searchQuery, minimalVariant, appendWildcard) =>
    wfetch(
        `${restUrl}?${new Date().getTime()}${minimalVariant ? "&rows=5" : ""}&q=${searchQuery}${
            appendWildcard ? "*" : ""
        }&qf=title%5E22+author%5E20+url%5E18+h1%5E16+keywords%5E14+abstract%5E13+categories%5E10+hx%5E9+content%5E8+description%5E4`,
    );

export const getDocs = (restUrl, searchQuery, minimalVariant = false) =>
    Promise.all([getResults(restUrl, searchQuery, minimalVariant, false), getResults(restUrl, searchQuery, minimalVariant, true)]).then(
        (results) => {
            let docs = [];

            for (const result of results) {
                if (!result.data || !result.data.response || !result.data.response.docs || result.data.response.docs.length === 0) continue;

                docs.push(...result.data.response.docs);
            }

            return populateDocs(docs);
        },
    );

export const highlightSearchQuery = (title, searchQuery) =>
    highlightSubstring(title, searchQuery.split(" ").join("|"), "search__highlighted-text");
